import Box from "@mui/material/Box";
import MobileDrawer from "./Drawers/MobileDrawer";
import DesktopDrawer from "./Drawers/DesktopDrawer";

const Sidebar = () => {
  return (
 <>
      <MobileDrawer />
      <DesktopDrawer />
 </>

  );
};
export default Sidebar;
